import { render, staticRenderFns } from "./select-type-expense.vue?vue&type=template&id=62994432&"
import script from "./select-type-expense.vue?vue&type=script&lang=js&"
export * from "./select-type-expense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports